import { Box, Divider, SearchInput, Text } from '@bitrise/bitkit';
import AppList from '../Search/AppList';
import useSearch from '../useSearch';

const HelpDrawer = (): JSX.Element => {
  const { query, setQuery, appList, isLoading } = useSearch();
  const isOpen = !!appList && !isLoading;
  return (
    <>
      <Box>
        <SearchInput
          autoFocus
          placeholder="Search projects..."
          onChange={(newValue) => setQuery(newValue)}
          paddingX="16"
        />
      </Box>
      <Divider marginTop="24" marginBottom="12" />
      <Box>
        {!query && (
          <Text textColor="neutral.40" fontSize="3" paddingX="24" paddingY="8">
            Start typing to get results.
          </Text>
        )}

        {query && appList && <AppList apps={appList} isOpen={isOpen} />}
      </Box>
    </>
  );
};

export default HelpDrawer;
